import createValidationElementUtil
from 'modules/redux/utils/create-validation-element'
import { defineMessages } from 'react-intl'
import { isEmailValidatorUtil } from 'utils/validators/is-email'

const messages = defineMessages({
  invalid: {
    id: 'emailValidatorUtil.invalid',
    defaultMessage: 'The {name} is invalid.',
    description: 'Used to validate an invalid value.'
  }
})

function emailValidatorUtil (value) {
  if (!isEmailValidatorUtil(value)) {
    return createValidationElementUtil(
      'email', messages.invalid, { name: 'Email' }
    )
  }
  return true
}

export default emailValidatorUtil
